import { Observable, of } from 'rxjs';

import { SignUpComponent } from './components/sign-up.component';

export const SignUpLostDataGuard = (
  component: SignUpComponent,
): Observable<boolean> => {
  return of(true); // component.checkIsUserFilledFirstStep();
};
